var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('iframe',{ref:"refIfrmContent",staticStyle:{"width":"100%","border":"none"},attrs:{"scrolling":"no","src":_vm.bodyUrl},on:{"load":_vm.onContentFrameLoaded}})
}
var staticRenderFns = []

export { render, staticRenderFns }